import React, { useState } from 'react';
import { Button, notification } from 'antd';

const TG_NOTI_URL = 'https://n29pbsmbbf.execute-api.ca-central-1.amazonaws.com/default/noraCakeAppSendToTelegram';
const NOT_API_KEY = 'LRrcjp2Rne2GcRdAjnopi6KvL19hL0Li3g3IMEjF';

const OrderButton = ({ 
  cakeName, 
  cakeId, 
  selectedSize, 
  selectedFlavour, 
  cakeMessage, 
  phoneNumber, 
  quantity, 
  customerName, 
  customerRequirement, 
  customerPreferredDate, 
  deliveryValue, 
  deliveryAddress 
}) => {
  const [loading, setLoading] = useState(false);
  const [api, contextHolder] = notification.useNotification();

  const openNotification = (cakeName) => {
    api.info({
      message: `Your ${cakeName} will be placed in our oven soon.`,
      description:
        'We will contact you soon to confirm your order and proceed the payment. Thank you for choosing Nora Cake!',
      placement: 'top',
    });
  };

  const isCustomerNameValid = () => {
    return customerName && customerName.trim() !== '';
  };

  const isCustomerPreferredDateValid = () => {
    return customerPreferredDate && customerPreferredDate !== '';
  };

  const isCustomerPhoneValid = () => {
    if (!phoneNumber || phoneNumber.trim() === '') return false;
    const phoneRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
    return phoneRegex.test(phoneNumber);
  };

  const isDeliveryAddressValid = () => {
    return deliveryAddress && deliveryAddress.trim() !== '';
  };

  const handleOrder = async () => {
    if (!isCustomerNameValid()) {
      alert("Please enter your name");
      return;
    }
    if (!isCustomerPreferredDateValid()) {
      alert("Please select a pickup date");
      return;
    }
    if (!isCustomerPhoneValid()) {
      alert("Please enter a valid phone number");
      return;
    }
    if (deliveryValue === 2 && !isDeliveryAddressValid()) {
      alert("Please enter delivery address");
      return;
    }

    const sizeLabel = selectedSize || 'None';
    const flavourLabel = selectedFlavour || 'None';

    let data = `*** Customer request ***
    Name: ${customerName}
    Phone: ${phoneNumber}
    Cake: ${cakeName}
    Cake ID: ${cakeId}
    Size: ${sizeLabel}
    Flavour: ${flavourLabel}
    Message on Cake: ${cakeMessage || 'None'}
    Quantity: ${quantity}
    Date: ${customerPreferredDate.toString()}
    Requirement: ${customerRequirement || 'None'}`;
    
    if (deliveryValue === 2) {
      data = data + `
    Delivery address: ${deliveryAddress}`;
    }

    setLoading(true);
    try {
      const response = await fetch(TG_NOTI_URL, {
        method: 'POST',
        headers: { 'x-api-key': NOT_API_KEY },
        body: JSON.stringify(data),
      });
      
      if (!response.ok) {
        alert("Error happening while placing the order");
        console.error(response);
      } else {
        openNotification(cakeName);
      }
    } catch (error) {
      alert("Error happening while placing the order");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {contextHolder}
      <Button 
        type="primary" 
        size="large"
        loading={loading}
        onClick={handleOrder}
        style={{ 
          width: '100%', 
          height: '48px', 
          fontSize: '16px',
          fontWeight: '600',
          marginTop: '24px'
        }}
      >
        Place Order
      </Button>
    </>
  );
};

export default OrderButton; 